import React, { useRef } from "react";
import PropTypes from "prop-types";
import Dialog from "../../components/modal";
import Button from "../../components/button";
import Input from "../../components/input";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { Row, Col } from "react-grid-system";

import { StyledDialogContent } from "./StyledDialogContent";
import { Label, InputStyle } from "../form/StyledForm";

import { Images, Colors } from "../../themes";

const CreateContent = ({
  dialogProps,
  image,
  titleCreate,
  description,
  textCreate,
  buttonText,
  urlCreate,
  onChangeText,
  onChangeImageCreate,
  onClickCreate,
  imageCreate,
}) => {
  const imageInputRef = useRef(null);

  const handleImageClick = () => {
    imageInputRef.current?.click();
  };

  return (
    <Dialog {...dialogProps} title="Create New Banner" width="76%">
      <StyledDialogContent>
        <Row>
          <Col>
            <Label htmlFor="title">Title</Label>
            <Input
              inputProps={{
                id: "title",
                value: titleCreate,
                name: "title",
                onChange: (e) => onChangeText("title", e.target.value),
              }}
              containerStyle={InputStyle}
            />
            <Label htmlFor="description">Description</Label>
            <Input
              inputProps={{
                id: "description",
                value: description,
                onChange: (e) => onChangeText("description", e.target.value),
              }}
              containerStyle={InputStyle}
            />
            <Label htmlFor="text">Text</Label>
            <div style={{ marginTop: "10px", marginBottom: "20px" }}>
              <Editor
                editorState={textCreate}
                onEditorStateChange={(editorState) =>
                  onChangeText("text", editorState)
                }
                wrapperClassName="editor-wrapper"
                editorClassName="editor-input"
                editorStyle={{
                  border: "0.5px solid #ccc",
                  padding: "10px",
                  minHeight: "200px",
                  borderRadius: "10px",
                }}
                toolbar={{
                  fontFamily: {
                    options: ["Arial"],
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                  },
                  colorPicker: {
                    className: undefined,
                    component: undefined,
                    popupClassName: undefined,
                    colors: [`#000000`],
                  },
                  fontSize: {
                    options: [14],
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                  },
                }}
              />
            </div>
            <Label htmlFor="buttonText">Button Text</Label>
            <Input
              inputProps={{
                id: "buttonText",
                value: buttonText,
                onChange: (e) => onChangeText("buttonText", e.target.value),
              }}
              containerStyle={InputStyle}
            />
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Label>Image</Label>
              <div className="image-container">
                <img
                  src={imageCreate || Images.thumbnail}
                  alt="banner"
                  className="banner-image"
                />
                <Button
                  text="Add image"
                  buttonStyle={` margin-top: 35px; `}
                  textStyle={` font-size: 13px; margin: 0 30px; font-weight: 800; `}
                  onClick={handleImageClick}
                />
                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={imageInputRef}
                  onChange={onChangeImageCreate}
                  accept="image/*"
                  required
                />
              </div>

              <Label htmlFor="url">URL</Label>
              <Input
                inputProps={{
                  id: "url",
                  value: urlCreate,
                  onChange: (e) => onChangeText("url", e.target.value),
                }}
                containerStyle={InputStyle}
              />
            </div>
            <div className="button-wrapper">
              <div style={{ width: "48%" }}>
                <Button
                  text="Discard"
                  textColor={Colors.color21}
                  buttonStyle={` background: ${Colors.color22}; box-shadow: 3px -3px 10px ${Colors.color3}, 3px 3px 10px ${Colors.color23}; `}
                />
              </div>
              <div style={{ width: "48%" }}>
                <Button
                  text="Save"
                  buttonStyle={` box-shadow: -3px -3px 10px ${Colors.color3}, 3px 3px 10px ${Colors.color23}; `}
                  onClick={onClickCreate}
                />
              </div>
            </div>
          </Col>
        </Row>
      </StyledDialogContent>
    </Dialog>
  );
};

CreateContent.propTypes = {
  dialogProps: PropTypes.object,
  image: PropTypes.string,
  titleCreate: PropTypes.string,
  description: PropTypes.string,
  textCreate: PropTypes.object,
  buttonText: PropTypes.string,
  urlCreate: PropTypes.string,
  onChangeText: PropTypes.func.isRequired,
  onChangeImageCreate: PropTypes.func.isRequired,
  onClickCreate: PropTypes.func.isRequired,
};

export default CreateContent;
